import {
  Component, OnInit, OnDestroy, inject, ChangeDetectorRef, ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { trigger, style, animate, transition } from '@angular/animations';
import { SharedModule } from '../shared.module';
import { InternalChatService } from '../../core/service/internalChat/internal-chat.service';

@Component({
  selector: 'app-internal-chat-notification',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './internal-chat-notification.component.html',
  styleUrl: './internal-chat-notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(110%)', opacity: 0 }),
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)',
          style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in',
          style({ transform: 'translateX(110%)', opacity: 0 }))
      ])
    ])
  ]
})
export class InternalChatNotificationComponent implements OnInit, OnDestroy {

  private readonly inboxService = inject(InternalChatService);
  private readonly router       = inject(Router);
  private readonly cdr          = inject(ChangeDetectorRef);

  visible  = false;
  message: any = null;
  time     = '';

  private sub?: Subscription;
  private timeout?: any;

  ngOnInit() {
    this.sub = this.inboxService.onMessageUpdate().subscribe((msg: any) => {
      // Only show notification when not on the internal chat page
      if (
        msg?.isAgentReply ||
        this.router.url.includes('/dashboard/internal-chat')
      ) return;

      this.showNotification(msg);
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.clearTimeout();
  }

  private showNotification(msg: any) {
    this.message = msg;
    this.time    = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });

    // Reset to re-trigger animation if already visible
    this.visible = false;
    this.cdr.detectChanges();
    this.clearTimeout();

    setTimeout(() => {
      this.visible = true;
      this.cdr.detectChanges();

      // Auto-dismiss after 8 seconds
      this.timeout = setTimeout(() => this.dismiss(), 80000);
    }, 50);
  }

  onView() {
    this.dismiss();
    if (!this.message?.conversationId) return;
    this.router.navigate(['/dashboard/internal-chat'], {
      queryParams: { id: this.message.conversationId }
    });
  }

  onDismiss(event: Event) {
    event.stopPropagation();
    this.dismiss();
  }

  private dismiss() {
    this.visible = false;
    this.clearTimeout();
    this.cdr.detectChanges();
  }

  private clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  getInitials(name: string): string {
    if (!name) return '?';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
  }
}